"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "spilamberto": {
    "ad93a445": [{
      "hkey": "edf77a9b",
      "slug": "spilamberto",
      "name": "Spilamberto",
      "primary": true,
      "skipSearch": false
    }],
    "bettolino": [{
      "hkey": "edf77a9b",
      "slug": "spilamberto",
      "name": "Spilamberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b6e3e782": [{
      "hkey": "edf77a9b",
      "slug": "spilamberto",
      "name": "Spilamberto",
      "primary": true,
      "skipSearch": false
    }],
    "campiglio": [{
      "hkey": "edf77a9b",
      "slug": "spilamberto",
      "name": "Spilamberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3276b729": [{
      "hkey": "edf77a9b",
      "slug": "spilamberto",
      "name": "Spilamberto",
      "primary": true,
      "skipSearch": false
    }],
    "poggioli": [{
      "hkey": "edf77a9b",
      "slug": "spilamberto",
      "name": "Spilamberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa9f8274": [{
      "hkey": "edf77a9b",
      "slug": "spilamberto",
      "name": "Spilamberto",
      "primary": true,
      "skipSearch": false
    }],
    "tavernelle": [{
      "hkey": "edf77a9b",
      "slug": "spilamberto",
      "name": "Spilamberto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;